import { useEffect, useRef, useState } from "react";
import { useUpdateEffect } from "react-use";
import { useResizeObserver } from "@activecollab/components";

const BREAKPOINT = 1024;

export const useEntityCardRenderAs = (displayMode = "grid") => {
  const bodyRef = useRef(document.body);
  const dimensions = useResizeObserver(bodyRef);
  const [renderAs, setRenderAs] = useState(() => {
    if (document.body.clientWidth < BREAKPOINT) {
      return "list";
    }
    return displayMode;
  });

  const isMobile = Boolean(dimensions?.width < BREAKPOINT);

  useEffect(() => {
    if (dimensions && dimensions.width < BREAKPOINT) {
      setRenderAs("list");
    }
    if (dimensions && dimensions.width >= BREAKPOINT) {
      setRenderAs(displayMode);
    }
  }, [dimensions, displayMode]);

  useUpdateEffect(() => {
    setRenderAs(displayMode);
  }, [displayMode]);
  return { renderAs, isMobile };
};
